import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'phoneNumberPipe' })
export class PhoneNumberPipe implements PipeTransform {
  transform(phoneNum: string): string {
    if (phoneNum) {
      let value = phoneNum.replace(/[^0-9]/g, "")
      let newNum = "(" + value.substring(0, 3) + ") " + value.substring(3, 6) + "-" + value.substring(6, 10);
      return newNum;
    }
    else {
      return phoneNum;
    }
  }
}